import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';

export const SAVE_BUCKET = 'saveBucket';
export const TOGGLE_BUCKET = 'toggleBucket';
export const DELETE_BUCKET = 'deleteBucket';
export const TEST_BUCKET_CONNECTION = 'testBucketConnection';

// TODO: Add types.
export const bucketFeedsApi = createApi({
  reducerPath: 'bucketFeedsApi',
  baseQuery,
  endpoints: (builder) => ({
    [SAVE_BUCKET]: builder.mutation<any, any>({
      query: ({ datasourceId, savedQueryId, payload }) => ({
        url: `datasources/${datasourceId}/views/${savedQueryId}/bucketFeeds`,
        method: 'POST',
        body: payload,
      }),
    }),
    [TOGGLE_BUCKET]: builder.mutation<any, any>({
      query: ({ datasourceId, savedQueryId, bucketFeedId, disabled }) => ({
        url: `datasources/${datasourceId}/views/${savedQueryId}/bucketFeeds/${bucketFeedId}/disable/${disabled}`,
        method: 'POST',
      }),
    }),
    [DELETE_BUCKET]: builder.mutation<any, any>({
      query: ({ datasourceId, savedQueryId, bucketFeedId }) => ({
        url: `datasources/${datasourceId}/views/${savedQueryId}/bucketFeeds/${bucketFeedId}`,
        method: 'DELETE',
      }),
    }),
    [TEST_BUCKET_CONNECTION]: builder.mutation<any, any>({
      query: ({ datasourceId, savedQueryId, payload }) => ({
        url: `datasources/${datasourceId}/views/${savedQueryId}/bucketFeeds/test`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useSaveBucketMutation,
  useToggleBucketMutation,
  useDeleteBucketMutation,
  useTestBucketConnectionMutation,
} = bucketFeedsApi;
